export default __webpack_public_path__ + "media/images/react_icons/best_deal-4851150a4ae6bdaf06f62e1322fc8706.svg";